module.exports = __webpack_public_path__ + "static/img/person.96311546.png";